import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=c7f665c8&scoped=true&"
import script from "./DishCard.vue?vue&type=script&lang=js&"
export * from "./DishCard.vue?vue&type=script&lang=js&"
import style0 from "./DishCard.vue?vue&type=style&index=0&id=c7f665c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f665c8",
  null
  
)

export default component.exports